import { useEffect, useState } from 'react';
import AsyncSelect from 'react-select/async';
import { components as defaultComponents } from 'react-select';
import useAxiosPrivate from '../../hooks/useAxiosPrivate';
import API_URLS from '../../constants/apiConstants';
import { useTranslation } from "react-i18next";

export const RoomsDropdown = ({ nurseryId, selectedRoom, setSelectedRoom }) => {
  const { t, i18n } = useTranslation();
  const isAr = i18n.language === 'ar';
  const [options, setOptions] = useState([]);
  const axiosPrivate = useAxiosPrivate();

  useEffect(() => {
    const fetchOptions = async () => {
      try {
        const api_url = API_URLS.getSchoolRooms(nurseryId);
        const response = await axiosPrivate.get(api_url);

        // Transform fetched rooms
        const fetchedRooms = response?.data?.map(room => ({
          value: room.id,
          labelEn: room.name, 
          labelAr: room.name,
        })) || [];

        // Add "All Rooms" as the first option
        const allRoomsOption = { value: "all", labelEn: "All Rooms" , labelAr: "جميع الصفوف" };

        const finalOptions = [allRoomsOption, ...fetchedRooms];

        setOptions(finalOptions);
        setSelectedRoom(allRoomsOption); // make "All Rooms" the default
      } catch (error) {
        // Do nothing
      }
    };

    fetchOptions();
  }, [axiosPrivate, nurseryId, setSelectedRoom]);

  const onChange = (option) => {
    if (!option?.value) return;
    setSelectedRoom(option);
  };

  return (
    <AsyncSelect
      cacheOptions
      defaultOptions={options}
      loadOptions={() => Promise.resolve([])} // disables search
      components={{ ...defaultComponents, IndicatorSeparator: () => null }}
      getOptionLabel={(option) => isAr ? option.labelAr : option.labelEn}
      value={selectedRoom}
      onChange={onChange}
      placeholder="Select a school"
      isClearable={false}
      isSearchable={false}
      styles={{
        control: (base, state) => ({
          ...base,
          fontSize: "0.9rem",
          minWidth: "8rem",
          border: "none",
          boxShadow: "none",
          outline: "none",
          backgroundColor: "var(--s-gray-color)",
          "&:hover": {
            backgroundColor: "#eee",
          },
        }),
        option: (base, state) => ({
          ...base,
          fontSize: "0.8rem",
          backgroundColor: state.isSelected
            ? "var(--s-purple-opacity-color)"
            : state.isFocused
            ? "#eee"
            : "white",
        }),
      }}
    />
  );
};
